export default IconSTurnUp => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-s-turn-up" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M7 19a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z" />
  <path d="M5 17v-9.5a3.5 3.5 0 0 1 7 0v9a3.5 3.5 0 0 0 7 0v-13.5" />
  <path d="M16 6l3 -3l3 3" />
</svg>`;